// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"694":"component---src-core-share-share-block-template-tsx","989":"component---src-core-pages-page-template-tsx"}[chunkId] + "-" + {"694":"32f54a1247c6cf03e05e","989":"cdb38c825d0704b327f0"}[chunkId] + ".js";
};